import axios from "axios";

const instance = axios.create({
  baseURL: "https://api.halla.in/api"
});

export default instance;
